import { IAllPaymentData } from '../../../../transactions/models/allPayments.model';
import { IDirectDebitState } from './state.interface';

export const DirectDebitState: IDirectDebitState = {
    allDirectDebit: null,
    singleDirectDebit: null,
    directDebitLoading: false,
    directDebitFailure: false,
    directDebitSuccess: false,
    singleDirectDebitLoading: false,
    singleDirectDebitFailure: false,
    singleDirectDebitSuccess: false,
    createDirectDebitLoading: false,
    createDirectDebitFailure: false,
    createDirectDebitSuccess: false,
    directDebitStatusLoading: false,
    directDebitStatusFailure: false,
    directDebitStatusSuccess: false,
    sendDirectDebitFailure: false,
    sendDirectDebitSuccess: false,
    sendDirectDebitLoading: false,
    createDirectDebitError: null,
    directDebitError: null,
    directDebitStatusError: null,
    sendDirectDebitError: null,
    singleDirectDebitError: null,
    deleteDirectDebitError: null,
    deleteDirectDebitFailure: false,
    deleteDirectDebitLoading: false,
    deleteDirectDebitMessgae: null,
    deleteDirectDebitSuccess: false,
    editDirectDebitError: null,
    editDirectDebitFailure: false,
    editDirectDebitLoading: false,
    editDirectDebitSuccess: false,
    directDebitStatusData: null,
    scheduleCustomerDebitFailure: false,
    scheduleCustomerDebitError: null,
    scheduleCustomerDebitLoading: false,
    scheduleCustomerDebitMessage: null,
    scheduleCustomerDebitSuccess: false,
    directDebitTransactionsSuccess: false,
    directDebitTransactionsLoading: false,
    directDebitTransactions: {} as IAllPaymentData,
    directDebitTransactionsFailure: false,
    cancelDirectDebit: false,
    cancelDirectDebitFailure: false,
    cancelDirectDebitSuccess: false
};
